
import React from 'react';

interface BlogErrorStateProps {
  error: Error | null;
}

export const BlogErrorState: React.FC<BlogErrorStateProps> = ({ error }) => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">Blog Management</h1>
      <div className="bg-red-50 border border-red-200 rounded p-4 text-red-700">
        Error loading posts: {error instanceof Error ? error.message : 'Unknown error'}
      </div>
    </div>
  );
};
